import axios from "axios";
import { getEntity } from "../utils/entities/getEntity";
import { entitiesQueryParamName } from "../utils/entities/constants";

const {
  REACT_APP_CAC_URL,
  REACT_APP_WALLET_URL,
  REACT_APP_CH_URL,
} = process.env;

interface CacUserProfile {
  profileId: number;
  profileName: string;
  expirationDate: string;
  renovationType: string;
  nextProfileId: number;
}

async function getCacUserProfile(cardNumber: string): Promise<CacUserProfile | undefined> {
  try {
    const entity = getEntity();
    const res = await axios.get<CacUserProfile>(
      `${REACT_APP_CAC_URL}/my-profile?${entitiesQueryParamName}=${entity.id}`
    );
    return res.data;
  } catch (err) {
    console.info("Error fetching CAC user profile:", err);
  }
}

/*
async function getCurrentRatesFares(date: Date | string) {
  const entityId: any = localStorage.getItem("entityId");
  const res = await axios.get(
    `${REACT_APP_SITFARES_URL}/fares/current-fare?entityId=${entityId}&date=${date}`
  );
  return res.data;
}

async function getReferenceFares(id: number) {
  const res = await axios.get(`${REACT_APP_SITFARES_URL}/referenceFares/${id}`);
  return res.data;
}

async function getBonificationRate() {
  const entityId: any = localStorage.getItem("entityId");
  const res = await axios.get(
    `${REACT_APP_SITFARES_URL}/bonuses/resident?entityId=${entityId}`
  );
  return res.data;
}
*/

async function getMyWalletInfo() {
  try {
    const entity = getEntity();
    const res = await axios.get(`${REACT_APP_WALLET_URL}/my-wallet?${entitiesQueryParamName}=${entity.id}`);
    return res.data;
  } catch (err) {
    console.info("Error fetching wallet info:", err);
  }
}

async function getNextTravel(jumps: number, points: number, profileId: number) {
  const entity = getEntity();
  try {
    const res = await axios.get(
      `${REACT_APP_CH_URL}/calculator-by-profile?jumps=${jumps}&points=${points}&profileId=${profileId}&date=${new Date()
        .toISOString()
        .slice(0, 16)}&${entitiesQueryParamName}=${entity.id}`
    );
    return res.data;
  } catch (err) {
    console.info("Error calculating next travel:", err);
  }
}

async function getBonusesResident(profileId: number) {
  try {
    const entity = getEntity();
    const res = await axios.get(
      `${REACT_APP_CH_URL}/points-by-profile?profileId=${profileId}&${entitiesQueryParamName}=${entity.id}`
    );
    return res.data;
  } catch (err) {
    console.info("Error fetching bonuses resident:", err);
  }
}

export const NextTravelApi = {
  getCacUserProfile,
  getMyWalletInfo,
  getNextTravel,
  getBonusesResident,
};
